<template>
  <div>
    <div class="wrap-float">
      <h1 class="subtitle align-left">Conseil : <strong>{{ tuto.title }}</strong></h1>
      <a class="button is-small is-white align-right" @click="changetuto('up')">
        <awesome-icon icon="chevron-right" />
      </a>
      <a class="button is-small is-white align-right" @click="changetuto('down')">
        <awesome-icon icon="chevron-left" />
      </a>
    </div>
    <div>{{ tuto.message }}</div>
  </div>
</template>

<script>
import { tutorials } from "../helpers";

export default {
  data() {
    return {
      tuto: { index: 0, title: "", message: "" }
    }
  },
  created() {
    let randomId = Math.floor(Math.random() * tutorials.length);
    this.tuto = {
      index: randomId,
      title: tutorials[randomId].title,
      message: tutorials[randomId].message
    };
  },
  methods: {
    changetuto(direction) {
      let index = 0
      if (direction == 'up') {
        index = this.tuto.index == tutorials.length - 1 ? 0 : this.tuto.index + 1;
      } else {
        index = this.tuto.index == 0 ? tutorials.length : this.tuto.index - 1;
      }
      this.tuto = {
        index: index,
        title: tutorials[index].title,
        message: tutorials[index].message
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.align-left {
  float: left;
}

.align-right {
  float: right;
}

.wrap-float {
  overflow: auto;

  & .subtitle {
    margin-bottom: .5rem;
  }
}
</style>